<template>
  <div class="main">
    <div v-if="sections && sections.length" class="content">
      <div
        v-for="(section, sectionIndex) in sections"
        :key="`section-${section.title || sectionIndex}`"
        class="section"
      >
        <h1 v-if="section.title" class="section-title">
          {{ section.title }}
        </h1>
        <div
          v-for="(item, itemIndex) in section.items"
          :key="`item-${item.label || itemIndex}`"
          class="item"
        >
          <p v-if="item.label" class="item-label">{{ item.label }}</p>
          <div v-if="item.values && item.values.length" class="item-values">
            <div
              v-for="(langItem, langIndex) in item.values"
              :key="`lang-${langItem.lang || langIndex}`"
              class="value-item"
            >
              <p v-if="langItem.lang" class="lang">{{ langItem.lang }}</p>
              <p v-if="langItem.text" class="value-text">{{ langItem.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StructuralSectionLayout",
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style scoped lang="scss">
.main {
  @apply flex flex-col items-start gap-12 bg-card p-8 w-full;
  flex: 1 0 0;
  border-radius: 20px;
  box-shadow: 0 1px 1px -0.5px rgba(0, 0, 0, 0.03),
    0 3px 3px -1.5px rgba(0, 0, 0, 0.03), 0 20px 20px -12px rgba(0, 0, 0, 0.03);
  .content {
    @apply flex flex-col items-start gap-8 self-stretch;
    .section {
      @apply flex flex-col items-start gap-6 self-stretch;
      .section-title {
        @apply flex items-center w-full font-semibold;
        font-size: 18px;
        line-height: 24px;
        color: hsl(var(--foreground));
      }
      .item {
        @apply flex flex-col items-start gap-3 self-stretch;
        .item-label {
          @apply text-sm font-normal;
          color: hsl(var(--muted-foreground));
        }
        .item-values {
          @apply flex items-start gap-3 self-stretch;
          flex-wrap: wrap;
          .value-item {
            @apply flex flex-col items-start min-w-[120px] min-h-14 py-[18px] px-4 justify-center self-stretch rounded-2xl;
            flex: 1 0 0;
            background: hsl(var(--muted));
            .lang {
              @apply flex self-stretch items-start text-xs font-normal;
              color: hsl(var(--muted-foreground));
            }
            .value-text {
              @apply font-normal;
              font-size: 16px;
              line-height: 20px;
              color: hsl(var(--muted-foreground));
            }
          }
        }
      }
    }
  }
}
</style>
